import axios from 'axios';
import { useEffect, useState } from 'react';
import { app } from '../config';
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
let url = `${app.URL}/org/fetchall`;

const useFetchUsers = () => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const token=getTokenfromUserObj();
  useEffect(() => {
    console.log("In Use effect")
    async function fetchData(){
      console.log("function is running")
      try {
        const res = await axios.get(`${app.URL}/user/getusers`,{headers:{auth:token}});
        console.log(res);
        setResponse(res.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
       fetchData();
  }, []);
console.log(response);
  return { loading, response, error };
};

export default useFetchUsers;
